export enum FeedbackType {
  General = "General feedback",
  FeatureImprovement = "I would like to suggest a new feature or improvement",
  SystemIssue = "I have an issue using the system"
}
